import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mwl-demo-utils-calendar-header',
  template: '<p>Desativando para upgrade, se necessário verificar commit anterior</p>'
})
export class CalendarHeaderComponent {
  @Input() view: string;

  @Input() viewDate: Date;

  @Input() locale: string = 'pt';

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
}
